import React, { useEffect, useState } from 'react'
import { SafeAreaView, ScrollView } from 'react-native'
import tw from 'tailwind-rn'
import { useDispatch } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'

import ActionCreators from '../../store/actions'
import { HGView, HGHeading } from '../../components/HGUI'
import { BlockGrid } from '../../components/Content'
import { RootStackParamList } from '../../navigators/AppNavigator'
// import { BlockType } from '../../config/types'

type Props = {
  navigation: StackNavigationProp<RootStackParamList, 'Documentation'>
}

const DocumentationOverviewScreen = (props: Props) => {
  const { navigation } = props
  const [resource, setResource] = useState<unknown | null>(null)
  const dispatch = useDispatch()
  // const { patientGroup } = useSelector((state) => state.user)

  const loadDocumentationOverviewResource = async () => {
    try {
      const result = await dispatch(
        ActionCreators.loadResource({ resourceId: '12' })
      )

      if (result?.title) {
        navigation.setOptions({ title: result.title })
      }

      setResource(result)
    } catch (e) {
      dispatch(ActionCreators.handleError(e))
    }
  }

  useEffect(() => {
    loadDocumentationOverviewResource()
  }, [])

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ScrollView style={tw('px-3')}>
        <HGView>
          <HGHeading>Dokumentation</HGHeading>

          <BlockGrid blocks={resource?.blocks || null} />
        </HGView>
      </ScrollView>
    </SafeAreaView>
  )
}

export default DocumentationOverviewScreen
